module.exports = __webpack_public_path__ + "img/rules__forbidden.09059036.png";